import { useCallback, useId } from 'react'
// import {
//     useController,
//     UseControllerProps,
//     type ControllerRenderProps,
// } from 'react-hook-form'

import { Checkbox, Label } from '@/shared/ui'

import {
    ContragentType,
    //  FormValues
} from './form/schema'

type TypeCheckboxProps = {
    value: ContragentType
    onChange: (v: ContragentType) => void
    checked: boolean
    label: string
    name: string
    disabled: boolean
}
// & Omit<ControllerRenderProps<FormValues>, 'value' | 'ref'>
const TypeCheckbox = ({
    value,
    checked,
    label,
    name,
    onChange: onChangeProp,
    // onBlur,
    disabled,
}: TypeCheckboxProps) => {
    const checkboxId = useId()

    const onChange = useCallback(
        () => onChangeProp(value),
        [onChangeProp, value]
    )

    return (
        <div className="flex">
            <Checkbox
                {...{
                    // onBlur, disabled,
                    onChange,
                    name,
                    checked,
                    value,
                    disabled,
                }}
                id={checkboxId}
            />
            <Label htmlFor={checkboxId} className="ml-2 text-xs">
                {label}
            </Label>
        </div>
    )
}

const physicalOptions = [
    { label: 'ФЛ', key: 'physical' as const },
    { label: 'ИП', key: 'ip' as const },
    { label: 'СЗ', key: 'self_employed' as const },
]

const juridicalOptions = [
    { label: 'ЮЛ', key: 'juridical' as const },
    { label: 'АНО', key: 'autonomous_non_profit_organization' as const },
]

// export type TypeCheckboxGroupProps = UseControllerProps<FormValues>
export type TypeCheckboxGroupProps = Pick<
    TypeCheckboxProps,
    'value' | 'onChange' | 'disabled'
> & {
    optionVariant: 'physical' | 'juridical'
}
export const TypeCheckboxGroup = ({
    value,
    onChange,
    disabled,
    optionVariant,
    // ...controllerProps
}: TypeCheckboxGroupProps) => {
    // const { field, fieldState: _fieldState } = useController(controllerProps)
    // const { value, ref: _ref, ...methods } = field

    const options =
        optionVariant === 'physical' ? physicalOptions : juridicalOptions

    return (
        <div className="flex gap-4">
            {options.map(({ label, key }) => {
                return (
                    <TypeCheckbox
                        // {...methods}
                        {...{ onChange, disabled }}
                        key={key}
                        name="type"
                        label={label}
                        value={key}
                        checked={value === key}
                    />
                )
            })}
        </div>
    )
}
